import { Navigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { normalizeApiRole } from '@/lib/routing';
import { AuthLoadingFallback } from '@/components/auth/ProtectedRoute';

/** Blocks PEMOHON until `payment_status === VERIFIED`. Other roles pass through. */
export function PaymentGate({ children }) {
  const { user, authHydrated } = useApp();
  if (!authHydrated) return <AuthLoadingFallback />;
  if (normalizeApiRole(user.role) === 'PEMOHON' && user.payment_status !== 'VERIFIED') {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

export default PaymentGate;
